import { type FC, type ReactNode } from 'react'
import { loadStripe } from '@stripe/stripe-js/pure'
import type { Stripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'
import { STRIPE_KEY } from 'shared/config'

let stripePromise: Promise<Stripe | null> | null = null

const getStripePromise = () => {
  if (!stripePromise && STRIPE_KEY) {
    stripePromise = loadStripe(STRIPE_KEY)
  }
  return stripePromise
}

export const StripeProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const stripe = getStripePromise()

  return (
    <>
      {stripe ? (
        <Elements
          stripe={stripe}
          options={{
            locale: 'en',
            fonts: [
              {
                family: 'Inter',
                src: 'url(/assets/Inter-Regular.woff)',
                weight: '400',
                cssSrc: 'https://fonts.googleapis.com/css2?family=Inter&display=swap',
              },
            ],
          }}
        >
          {children}
        </Elements>
      ) : (
        children
      )}
    </>
  )
}
